/**
 * Ultimate Variant Fix - The most aggressive approach to ensure correct variant is added
 * This script runs last and overrides everything else
 */

(function() {
  'use strict';
  
  console.log('Ultimate Variant Fix: Starting');
  
  let correctVariantId = null;
  let isFormSubmission = false;
  let lastSubmittedCartForm = null;
  
  // Function to get the currently selected variant ID
  function getCurrentVariantId() {
    const activeForm = lastSubmittedCartForm || document.querySelector('form[action*="/cart/add"]');
    if (!activeForm) return null;
    
    const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
    if (!variantPicker) return null;
    
    // Check all possible ways to get the selected variant
    const selectedRadio = variantPicker.querySelector('input[type="radio"]:checked');
    if (selectedRadio?.dataset.variantId) return selectedRadio.dataset.variantId;
    
    const selectedOption = variantPicker.querySelector('select option:checked');
    if (selectedOption?.dataset.variantId) return selectedOption.dataset.variantId;
    
    const checkedInput = variantPicker.querySelector('input:checked');
    if (checkedInput?.dataset.variantId) return checkedInput.dataset.variantId;
    
    return null;
  }
  
  // Track variant changes
  document.addEventListener('change', function(event) {
    if (event.target.closest('variant-picker')) {
      const variantId = event.target.dataset.variantId;
      if (variantId) {
        correctVariantId = variantId;
        console.log('Ultimate Fix: Stored variant ID from change:', correctVariantId);
      }
    }
  });
  
  document.addEventListener('variant:update', function(event) {
    if (event.detail?.resource?.id) {
      correctVariantId = event.detail.resource.id;
      console.log('Ultimate Fix: Stored variant ID from VariantUpdateEvent:', correctVariantId);
    }
  });
  
  document.addEventListener('variant:selected', function(event) {
    if (event.detail?.resource?.id) {
      correctVariantId = event.detail.resource.id;
      console.log('Ultimate Fix: Stored variant ID from VariantSelectedEvent:', correctVariantId);
    }
  });
  
  // Track form submissions
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form?.action?.includes('/cart/add')) {
      isFormSubmission = true;
      lastSubmittedCartForm = form;
      console.log('Ultimate Fix: Form submission detected');
      
      // Get the current variant ID
      const currentVariantId = getCurrentVariantId();
      if (currentVariantId) {
        correctVariantId = currentVariantId;
        console.log('Ultimate Fix: Current selected variant ID:', correctVariantId);
        
        // Force update the form
        const variantIdInput = form.querySelector('input[name="id"]');
        if (variantIdInput) {
          const oldValue = variantIdInput.value;
          variantIdInput.value = correctVariantId;
          console.log('Ultimate Fix: Updated form variant ID from', oldValue, 'to', correctVariantId);
          
          // Dispatch events
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      
      // Reset flag after a delay
      setTimeout(() => {
        isFormSubmission = false;
      }, 1000);
    }
  }, true);
  
  // Override fetch with maximum aggression
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (url?.includes('/cart/add')) {
      console.log('Ultimate Fix: Intercepting fetch to /cart/add');
      
      // Always get the current variant ID
      const currentVariantId = getCurrentVariantId();
      if (currentVariantId) {
        correctVariantId = currentVariantId;
        console.log('Ultimate Fix: Fetch - Current variant ID:', correctVariantId);
      }
      
      if (options?.body instanceof FormData) {
        const formData = options.body;
        const currentFormVariantId = formData.get('id');
        
        console.log('Ultimate Fix: Fetch - Form variant ID:', currentFormVariantId);
        console.log('Ultimate Fix: Fetch - Correct variant ID:', correctVariantId);
        
        if (correctVariantId && currentFormVariantId !== correctVariantId) {
          console.log('Ultimate Fix: Fetch - forcing variant ID from', currentFormVariantId, 'to', correctVariantId);
          formData.set('id', correctVariantId);
          formData.set('variant_id', correctVariantId);
          formData.set('variantId', correctVariantId);
          
          // Also try other possible field names
          formData.set('variant', correctVariantId);
          formData.set('product_variant_id', correctVariantId);
        }
      } else if (options && typeof options.body === 'string') {
        // Handle JSON or URL-encoded payloads
        const contentType = (options.headers && (options.headers['Content-Type'] || options.headers['content-type'])) || '';
        try {
          if (contentType.includes('application/json')) {
            const parsed = JSON.parse(options.body);
            const currentFormVariantId = parsed?.id || parsed?.items?.[0]?.id;
            console.log('Ultimate Fix: Fetch JSON - body variant ID:', currentFormVariantId);
            if (correctVariantId) {
              if (parsed.id && parsed.id !== correctVariantId) parsed.id = correctVariantId;
              if (parsed.items && parsed.items[0] && parsed.items[0].id !== correctVariantId) parsed.items[0].id = correctVariantId;
              options.body = JSON.stringify(parsed);
              console.log('Ultimate Fix: Fetch JSON - forced variant ID to', correctVariantId);
            }
          } else if (contentType.includes('application/x-www-form-urlencoded')) {
            const params = new URLSearchParams(options.body);
            const currentFormVariantId = params.get('id');
            console.log('Ultimate Fix: Fetch URL-Encoded - body variant ID:', currentFormVariantId);
            if (correctVariantId && currentFormVariantId !== String(correctVariantId)) {
              params.set('id', correctVariantId);
              options.body = params.toString();
              console.log('Ultimate Fix: Fetch URL-Encoded - forced variant ID to', correctVariantId);
            }
          }
        } catch (e) {
          console.warn('Ultimate Fix: Fetch - could not parse body for variant correction');
        }
      }
    }
    
    return originalFetch.call(this, url, options);
  };
  
  // Override XMLHttpRequest with maximum aggression
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this._url = url;
    return originalXHROpen.call(this, method, url, ...args);
  };
  
  XMLHttpRequest.prototype.send = function(data) {
    if (this._url?.includes('/cart/add')) {
      console.log('Ultimate Fix: Intercepting XHR to /cart/add');
      
      // Always get the current variant ID
      const currentVariantId = getCurrentVariantId();
      if (currentVariantId) {
        correctVariantId = currentVariantId;
        console.log('Ultimate Fix: XHR - current variant ID:', correctVariantId);
      }
      
      if (data instanceof FormData) {
        const currentFormVariantId = data.get('id');
        
        console.log('Ultimate Fix: XHR - form variant ID:', currentFormVariantId);
        console.log('Ultimate Fix: XHR - correct variant ID:', correctVariantId);
        
        if (correctVariantId && currentFormVariantId !== correctVariantId) {
          console.log('Ultimate Fix: XHR - forcing variant ID from', currentFormVariantId, 'to', correctVariantId);
          data.set('id', correctVariantId);
          data.set('variant_id', correctVariantId);
          data.set('variantId', correctVariantId);
          data.set('variant', correctVariantId);
          data.set('product_variant_id', correctVariantId);
        }
      }
    }
    
    return originalXHRSend.call(this, data);
  };
  
  // Override FormData.set with maximum aggression
  const originalFormDataSet = FormData.prototype.set;
  FormData.prototype.set = function(name, value) {
    if (name === 'id' && correctVariantId && value !== correctVariantId) {
      console.log('Ultimate Fix: FormData.set intercepted - forcing variant ID from', value, 'to', correctVariantId);
      value = correctVariantId;
    }
    return originalFormDataSet.call(this, name, value);
  };
  
  // Override any possible Recharge functions
  function overrideRechargeFunctions() {
    if (window.Recharge) {
      console.log('Ultimate Fix: Overriding Recharge functions');
      
      // Override all possible Recharge cart functions
      if (window.Recharge.Cart?.updateCart) {
        const originalUpdateCart = window.Recharge.Cart.updateCart;
        window.Recharge.Cart.updateCart = function(data, callback) {
          console.log('Ultimate Fix: Intercepting Recharge.Cart.updateCart');
          if (data?.items?.[0] && correctVariantId) {
            console.log('Ultimate Fix: Recharge - forcing variant ID from', data.items[0].variant_id, 'to', correctVariantId);
            data.items[0].variant_id = correctVariantId;
          }
          return originalUpdateCart.call(this, data, callback);
        };
      }
      
      if (window.Recharge.cart?.addToCart) {
        const originalAddToCart = window.Recharge.cart.addToCart;
        window.Recharge.cart.addToCart = function(variantId, quantity, properties) {
          console.log('Ultimate Fix: Intercepting Recharge.cart.addToCart');
          if (correctVariantId && variantId !== correctVariantId) {
            console.log('Ultimate Fix: Recharge - forcing variant ID from', variantId, 'to', correctVariantId);
            variantId = correctVariantId;
          }
          return originalAddToCart.call(this, variantId, quantity, properties);
        };
      }
    }
  }
  
  // Run immediately and also on interval
  overrideRechargeFunctions();
  setInterval(overrideRechargeFunctions, 1000);
  
  // Override any global cart functions
  if (window.addToCart) {
    const originalAddToCart = window.addToCart;
    window.addToCart = function(variantId, quantity, properties) {
      console.log('Ultimate Fix: Intercepting global addToCart');
      if (correctVariantId && variantId !== correctVariantId) {
        console.log('Ultimate Fix: Global addToCart - forcing variant ID from', variantId, 'to', correctVariantId);
        variantId = correctVariantId;
      }
      return originalAddToCart.call(this, variantId, quantity, properties);
    };
  }
  
  console.log('Ultimate Variant Fix: Initialized');
  
})();
